/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
/* tslint:disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as import0 from '../../../../app/core/modeling.component/modeling.component';
import * as import1 from '@angular/core/src/change_detection/change_detection_util';
import * as import2 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/security';
import * as import6 from '@angular/core/src/metadata/view';
import * as import7 from '../../../../app/services/computation.service';
import * as import8 from '../../../../app/services/error.handler.service';
import * as import9 from '../../../../app/services/specific.service';
import * as import10 from '../../../../app/services/dialogs.service';
import * as import11 from '../../../../app/services/dom.service';
import * as import12 from '@angular/core/src/linker/view_type';
import * as import13 from '@angular/core/src/change_detection/constants';
import * as import14 from '@angular/core/src/linker/component_factory';
import * as import15 from '@angular/material/dialog/dialog';
import * as import16 from '../../../../app/services/d3.service';
import * as import17 from './modeling.component.css.shim.ngstyle';
import * as import18 from '@angular/core/src/animation/animation_transition';
import * as import19 from '@angular/core/src/animation/animation_sequence_player';
import * as import20 from '@angular/core/src/animation/animation_styles';
import * as import21 from '@angular/core/src/animation/animation_style_util';
import * as import22 from '@angular/core/src/animation/animation_keyframe';
import * as import23 from '@angular/core/src/animation/animation_player';
import * as import24 from '@angular/core/src/linker/view_container';
import * as import25 from '../../../../app/shared/inputs.component/input.component';
import * as import26 from '../../../../app/services/inut.validator.service';
import * as import27 from '../../shared/inputs.component/input.component.ngfactory';
import * as import28 from '../../../node_modules/@angular/material/core/compatibility/compatibility.ngfactory';
import * as import29 from '../../../node_modules/@angular/material/tooltip/tooltip.ngfactory';
import * as import30 from '@angular/material/core/compatibility/compatibility';
import * as import31 from '@angular/material/core/overlay/overlay';
import * as import32 from '@angular/material/core/overlay/scroll/scroll-dispatcher';
import * as import33 from '@angular/core/src/linker/element_ref';
import * as import34 from '@angular/core/src/zone/ng_zone';
import * as import35 from '@angular/material/core/rtl/dir';
import * as import36 from '@angular/material/tooltip/tooltip';
import * as import37 from '@angular/core/src/linker/query_list';
import * as import38 from '../../../node_modules/@angular/forms/src/directives/ng_form.ngfactory';
import * as import39 from '../../../node_modules/@angular/forms/src/directives/ng_control_status.ngfactory';
import * as import40 from '../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import41 from '@angular/material/button/button';
import * as import42 from '../../../node_modules/@angular/material/button/button.ngfactory';
import * as import43 from '../../../../app/shared/progress.spinner/spinner.component';
import * as import44 from '../../shared/progress.spinner/spinner.component.ngfactory';
import * as import45 from '@angular/core/src/linker/template_ref';
import * as import46 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import47 from '@angular/common/src/directives/ng_for';
import * as import48 from '@angular/forms/src/directives/ng_form';
import * as import49 from '@angular/forms/src/directives/control_container';
import * as import50 from '@angular/forms/src/directives/ng_control_status';
import * as import51 from '@angular/material/dialog/dialog-ref';
import * as import52 from '../../../../app/shared/stub.component/stub.component';
import * as import53 from '../../shared/stub.component/stub.component.ngfactory';
var Wrapper_ModelingComponent = (function () {
    function Wrapper_ModelingComponent(p0, p1, p2, p3, p4, p5) {
        this._changed = false;
        this.context = new import0.ModelingComponent(p0, p1, p2, p3, p4, p5);
        this._expr_0 = import1.UNINITIALIZED;
        this._expr_1 = import1.UNINITIALIZED;
    }
    Wrapper_ModelingComponent.prototype.ngOnDetach = function (view, componentView, el) {
        var animationTransition_routeAnimationRight = componentView.componentType.animations['routeAnimationRight'](view, el, this._expr_0, 'void');
    };
    Wrapper_ModelingComponent.prototype.ngOnDestroy = function () {
    };
    Wrapper_ModelingComponent.prototype.ngDoCheck = function (view, el, throwOnChange) {
        var changed = this._changed;
        this._changed = false;
        return changed;
    };
    Wrapper_ModelingComponent.prototype.checkHost = function (view, componentView, el, throwOnChange) {
        var currVal_0 = this.context.routeAnimationRight;
        if (import3.checkBinding(throwOnChange, this._expr_0, currVal_0)) {
            var animationTransition_routeAnimationRight = componentView.componentType.animations['routeAnimationRight'](view, el, ((this._expr_0 == import1.UNINITIALIZED) ? 'void' : this._expr_0), ((currVal_0 == import1.UNINITIALIZED) ? 'void' : currVal_0));
            this._expr_0 = currVal_0;
        }
        var currVal_1 = this.context.position;
        if (import3.checkBinding(throwOnChange, this._expr_1, currVal_1)) {
            view.renderer.setElementStyle(el, 'position', ((view.viewUtils.sanitizer.sanitize(import4.SecurityContext.STYLE, currVal_1) == null) ? null : view.viewUtils.sanitizer.sanitize(import4.SecurityContext.STYLE, currVal_1).toString()));
            this._expr_1 = currVal_1;
        }
    };
    Wrapper_ModelingComponent.prototype.handleEvent = function (eventName, $event) {
        var result = true;
        if ((eventName == 'click')) {
            var pd_sub_0 = (this.context.clickHandler($event) !== false);
            result = (pd_sub_0 && result);
        }
        return result;
    };
    Wrapper_ModelingComponent.prototype.subscribe = function (view, _eventHandler) {
        this._eventHandler = _eventHandler;
    };
    return Wrapper_ModelingComponent;
}());
export { Wrapper_ModelingComponent };
var Wrapper_ModalWindowComponent = (function () {
    function Wrapper_ModalWindowComponent(p0) {
        this._changed = false;
        this.context = new import0.ModalWindowComponent(p0);
    }
    Wrapper_ModalWindowComponent.prototype.ngOnDetach = function (view, componentView, el) {
    };
    Wrapper_ModalWindowComponent.prototype.ngOnDestroy = function () {
    };
    Wrapper_ModalWindowComponent.prototype.ngDoCheck = function (view, el, throwOnChange) {
        var changed = this._changed;
        this._changed = false;
        return changed;
    };
    Wrapper_ModalWindowComponent.prototype.checkHost = function (view, componentView, el, throwOnChange) {
    };
    Wrapper_ModalWindowComponent.prototype.handleEvent = function (eventName, $event) {
        var result = true;
        return result;
    };
    Wrapper_ModalWindowComponent.prototype.subscribe = function (view, _eventHandler) {
        this._eventHandler = _eventHandler;
    };
    return Wrapper_ModalWindowComponent;
}());
export { Wrapper_ModalWindowComponent };
var renderType_ModelingComponent_Host = import3.createRenderComponentType('', 0, import6.ViewEncapsulation.None, [], {});
var View_ModelingComponent_Host0 = (function (_super) {
    __extends(View_ModelingComponent_Host0, _super);
    function View_ModelingComponent_Host0(viewUtils, parentView, parentIndex, parentElement) {
        return _super.call(this, View_ModelingComponent_Host0, renderType_ModelingComponent_Host, import12.ViewType.HOST, viewUtils, parentView, parentIndex, parentElement, import13.ChangeDetectorStatus.CheckAlways) || this;
    }
    View_ModelingComponent_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer, 'ng-component', import3.EMPTY_INLINE_ARRAY, rootSelector, null);
        this.compView_0 = new View_ModelingComponent0(this.viewUtils, this, 0, this._el_0);
        this._ComputationService_0_3 = new import7.ComputationService();
        this._ErrorHandlerService_0_4 = new import8.ErrorHandlerService();
        this._SpecificService_0_5 = new import9.SpecificService();
        this._DialogsService_0_6 = new import10.DialogsService(this.injectorGet(import15.MdDialog, this.parentIndex));
        this._DOMService_0_7 = new import11.DOMService(this.renderer);
        this._ModelingComponent_0_8 = new Wrapper_ModelingComponent(this.injectorGet(import16.D3Service, this.parentIndex), this._ComputationService_0_3, this._ErrorHandlerService_0_4, this._SpecificService_0_5, this._DialogsService_0_6, this._DOMService_0_7);
        this.compView_0.create(this._ModelingComponent_0_8.context);
        var disposable_0 = import3.subscribeToRenderElement(this, this._el_0, new import3.InlineArray2(2, 'click', null), this.eventHandler(this.handleEvent_0));
        this._ModelingComponent_0_8.subscribe(this, this.eventHandler(this.handleEvent_0));
        this.init(this._el_0, (this.renderer.directRenderer ? null : [this._el_0]), [disposable_0]);
        return new import14.ComponentRef_(0, this, this._el_0, this._ModelingComponent_0_8.context);
    };
    View_ModelingComponent_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import7.ComputationService) && (0 === requestNodeIndex))) {
            return this._ComputationService_0_3;
        }
        if (((token === import8.ErrorHandlerService) && (0 === requestNodeIndex))) {
            return this._ErrorHandlerService_0_4;
        }
        if (((token === import9.SpecificService) && (0 === requestNodeIndex))) {
            return this._SpecificService_0_5;
        }
        if (((token === import10.DialogsService) && (0 === requestNodeIndex))) {
            return this._DialogsService_0_6;
        }
        if (((token === import11.DOMService) && (0 === requestNodeIndex))) {
            return this._DOMService_0_7;
        }
        if (((token === import0.ModelingComponent) && (0 === requestNodeIndex))) {
            return this._ModelingComponent_0_8.context;
        }
        return notFoundResult;
    };
    View_ModelingComponent_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._ModelingComponent_0_8.ngDoCheck(this, this._el_0, throwOnChange);
        this._ModelingComponent_0_8.checkHost(this, this.compView_0, this._el_0, throwOnChange);
        this.compView_0.internalDetectChanges(throwOnChange);
        if (!throwOnChange) {
            if ((this.numberOfChecks === 0)) {
                this._ModelingComponent_0_8.context.ngAfterViewInit();
            }
        }
    };
    View_ModelingComponent_Host0.prototype.destroyInternal = function () {
        this.compView_0.destroy();
    };
    View_ModelingComponent_Host0.prototype.detachInternal = function () {
        this._ModelingComponent_0_8.ngOnDetach(this, this.compView_0, this._el_0);
    };
    View_ModelingComponent_Host0.prototype.visitRootNodesInternal = function (cb, ctx) {
        cb(this._el_0, ctx);
    };
    View_ModelingComponent_Host0.prototype.handleEvent_0 = function (eventName, $event) {
        this.compView_0.markPathToRootAsCheckOnce();
        var result = true;
        result = (this._ModelingComponent_0_8.handleEvent(eventName, $event) && result);
        return result;
    };
    return View_ModelingComponent_Host0;
}(import2.AppView));
export var ModelingComponentNgFactory = new import14.ComponentFactory('ng-component', View_ModelingComponent_Host0, import0.ModelingComponent);
var styles_ModelingComponent = [import17.styles];
var ModelingComponent_routeAnimationRight_states = {
    '*': {
        'opacity': '1',
        'transform': 'translateX(0)'
    },
    'void': {}
};
function ModelingComponent_routeAnimationRight_factory(view, element, currentState, nextState) {
    var previousPlayers = view.animationContext.getAnimationPlayers(element, ((nextState == 'void') ? null : 'routeAnimationRight'));
    var collectedStyles = {};
    var player = null;
    var totalTime = 0;
    var defaultStateStyles = ModelingComponent_routeAnimationRight_states['*'];
    var startStateStyles = ModelingComponent_routeAnimationRight_states[currentState];
    if ((startStateStyles == null)) {
        (startStateStyles = defaultStateStyles);
    }
    var endStateStyles = ModelingComponent_routeAnimationRight_states[nextState];
    if ((endStateStyles == null)) {
        (endStateStyles = defaultStateStyles);
    }
    if (((player == null) && ((currentState == 'void') && true))) {
        player = new import19.AnimationSequencePlayer([view.renderer.animate(element, new import20.AnimationStyles(import21.collectAndResolveStyles(collectedStyles, [
                startStateStyles,
                {
                    'opacity': '0',
                    'transform': 'translateX(100%)'
                }
            ])), import21.balanceAnimationKeyframes(collectedStyles, endStateStyles, [
                new import22.AnimationKeyframe(0, new import20.AnimationStyles(import21.collectAndResolveStyles(collectedStyles, [{}]))),
                new import22.AnimationKeyframe(1, new import20.AnimationStyles(import21.collectAndResolveStyles(collectedStyles, [{}])))
            ]), 400, 0, 'ease-in', previousPlayers)]);
        totalTime = 400;
    }
    if (((player == null) && (true && (nextState == 'void')))) {
        player = new import19.AnimationSequencePlayer([view.renderer.animate(element, new import20.AnimationStyles(import21.collectAndResolveStyles(collectedStyles, [startStateStyles])), [
                new import22.AnimationKeyframe(0, new import20.AnimationStyles(import21.collectAndResolveStyles(collectedStyles, [{
                        'opacity': 'true',
                        'transform': 'true'
                    }
                ]))),
                new import22.AnimationKeyframe(1, new import20.AnimationStyles(import21.collectAndResolveStyles(collectedStyles, [{
                        'opacity': '0',
                        'transform': 'translateX(100%)'
                    }
                ])))
            ], 400, 0, 'ease-out', previousPlayers)]);
        totalTime = 400;
    }
    if ((player == null)) {
        (player = new import23.NoOpAnimationPlayer());
    }
    player.onDone(function () {
        player.destroy();
        import21.renderStyles(element, view.renderer, import21.prepareFinalAnimationStyles(startStateStyles, endStateStyles));
    });
    new import19.AnimationSequencePlayer(previousPlayers).destroy();
    import21.renderStyles(element, view.renderer, import21.clearStyles(startStateStyles));
    view.animationContext.queueAnimation(element, 'routeAnimationRight', player);
    return new import18.AnimationTransition(player, currentState, nextState, totalTime);
}
var ModelingComponent_openHide_states = {
    'in': {
        'display': 'block',
        'opacity': '1',
        'transform': 'translateZ(0)'
    },
    'out': {
        'display': 'none',
        'opacity': '0',
        'transform': 'translateZ(0)'
    },
    '*': {}
};
function ModelingComponent_openHide_factory(view, element, currentState, nextState) {
    var previousPlayers = view.animationContext.getAnimationPlayers(element, ((nextState == 'void') ? null : 'openHide'));
    var collectedStyles = {};
    var player = null;
    var totalTime = 0;
    var defaultStateStyles = ModelingComponent_openHide_states['*'];
    var startStateStyles = ModelingComponent_openHide_states[currentState];
    if ((startStateStyles == null)) {
        (startStateStyles = defaultStateStyles);
    }
    var endStateStyles = ModelingComponent_openHide_states[nextState];
    if ((endStateStyles == null)) {
        (endStateStyles = defaultStateStyles);
    }
    if (((player == null) && ((currentState == 'in') && (nextState == 'out')))) {
        player = new import19.AnimationSequencePlayer([view.renderer.animate(element, new import20.AnimationStyles(import21.collectAndResolveStyles(collectedStyles, [startStateStyles])), import21.balanceAnimationKeyframes(collectedStyles, endStateStyles, [
                new import22.AnimationKeyframe(0, new import20.AnimationStyles(import21.collectAndResolveStyles(collectedStyles, [{}]))),
                new import22.AnimationKeyframe(1, new import20.AnimationStyles(import21.collectAndResolveStyles(collectedStyles, [{}])))
            ]), 300, 0, null, previousPlayers)]);
        totalTime = 300;
    }
    if (((player == null) && ((currentState == 'out') && (nextState == 'in')))) {
        player = new import19.AnimationSequencePlayer([view.renderer.animate(element, new import20.AnimationStyles(import21.collectAndResolveStyles(collectedStyles, [startStateStyles])), import21.balanceAnimationKeyframes(collectedStyles, endStateStyles, [
                new import22.AnimationKeyframe(0, new import20.AnimationStyles(import21.collectAndResolveStyles(collectedStyles, [{}]))),
                new import22.AnimationKeyframe(1, new import20.AnimationStyles(import21.collectAndResolveStyles(collectedStyles, [{}])))
            ]), 300, 0, null, previousPlayers)]);
        totalTime = 300;
    }
    if ((player == null)) {
        (player = new import23.NoOpAnimationPlayer());
    }
    player.onDone(function () {
        player.destroy();
        import21.renderStyles(element, view.renderer, import21.prepareFinalAnimationStyles(startStateStyles, endStateStyles));
    });
    new import19.AnimationSequencePlayer(previousPlayers).destroy();
    import21.renderStyles(element, view.renderer, import21.clearStyles(startStateStyles));
    view.animationContext.queueAnimation(element, 'openHide', player);
    return new import18.AnimationTransition(player, currentState, nextState, totalTime);
}
var View_ModelingComponent1 = (function (_super) {
    __extends(View_ModelingComponent1, _super);
    function View_ModelingComponent1(viewUtils, parentView, parentIndex, parentElement, declaredViewContainer) {
        return _super.call(this, View_ModelingComponent1, renderType_ModelingComponent, import12.ViewType.EMBEDDED, viewUtils, parentView, parentIndex, parentElement, import13.ChangeDetectorStatus.CheckAlways, declaredViewContainer) || this;
    }
    View_ModelingComponent1.prototype.createInternal = function (rootSelector) {
        this._el_0 = import3.createRenderElement(this.renderer, null, 'app-input', new import3.InlineArray2(2, 'class', 'modeling__inputs'), null);
        this._vc_0 = new import24.ViewContainer(0, null, this, this._el_0);
        this.compView_0 = new import27.View_InputComponent0(this.viewUtils, this, 0, this._el_0);
        this._InputValidatorService_0_5 = new import26.InputValidatorService();
        this._InputComponent_0_6 = new import27.Wrapper_InputComponent(this._InputValidatorService_0_5);
        this._MdPrefixRejector_0_7 = new import28.Wrapper_MdPrefixRejector(this.parentView.parentView.injectorGet(import30.MATERIAL_COMPATIBILITY_MODE, this.parentView.parentIndex, null));
        this._MdTooltip_0_8 = new import29.Wrapper_MdTooltip(this.parentView.parentView.injectorGet(import31.Overlay, this.parentView.parentIndex), this.parentView.parentView.injectorGet(import32.ScrollDispatcher, this.parentView.parentIndex), new import33.ElementRef(this._el_0), this._vc_0.vcRef, this.parentView.parentView.injectorGet(import34.NgZone, this.parentView.parentIndex), this.parentView.parentView.injectorGet(import35.Dir, this.parentView.parentIndex, null));
        this._text_1 = this.renderer.createText(null, '\n            ', null);
        this.compView_0.create(this._InputComponent_0_6.context);
        this._el_2 = this.renderer.createTemplateAnchor(null, null);
        var disposable_0 = import3.subscribeToRenderElement(this, this._el_0, new import3.InlineArray8(8, 'longpress', null, 'touchend', null, 'mouseenter', null, 'mouseleave', null), this.eventHandler(this.handleEvent_0));
        this.init(this._el_2, (this.renderer.directRenderer ? null : [
            this._el_0,
            this._text_1
        ]), [disposable_0]);
        return null;
    };
    View_ModelingComponent1.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import26.InputValidatorService) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) {
            return this._InputValidatorService_0_5;
        }
        if (((token === import25.InputComponent) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) {
            return this._InputComponent_0_6.context;
        }
        if (((token === import30.MdPrefixRejector) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) {
            return this._MdPrefixRejector_0_7.context;
        }
        if (((token === import36.MdTooltip) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) {
            return this._MdTooltip_0_8.context;
        }
        return notFoundResult;
    };
    View_ModelingComponent1.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_0_0_0 = this.context.$implicit;
        this._InputComponent_0_6.check_input(currVal_0_0_0, throwOnChange, false);
        this._InputComponent_0_6.ngDoCheck(this, this._el_0, throwOnChange);
        this._MdPrefixRejector_0_7.ngDoCheck(this, this._el_0, throwOnChange);
        var currVal_0_2_0 = this.parentView.context.TOOLTIPPOS;
        this._MdTooltip_0_8.check_position(currVal_0_2_0, throwOnChange, false);
        var currVal_0_2_1 = this.parentView.context.TOOLTIPD;
        this._MdTooltip_0_8.check_showDelay(currVal_0_2_1, throwOnChange, false);
        var currVal_0_2_2 = this.context.$implicit.toolTip;
        this._MdTooltip_0_8.check_message(currVal_0_2_2, throwOnChange, false);
        this._MdTooltip_0_8.ngDoCheck(this, this._el_0, throwOnChange);
        this._vc_0.detectChangesInNestedViews(throwOnChange);
        this.compView_0.internalDetectChanges(throwOnChange);
    };
    View_ModelingComponent1.prototype.destroyInternal = function () {
        this._vc_0.destroyNestedViews();
        this.compView_0.destroy();
        this._MdTooltip_0_8.ngOnDestroy();
    };
    View_ModelingComponent1.prototype.visitRootNodesInternal = function (cb, ctx) {
        cb(this._vc_0.nativeElement, ctx);
        this._vc_0.visitNestedViewRootNodes(cb, ctx);
        cb(this._el_2, ctx);
    };
    View_ModelingComponent1.prototype.handleEvent_0 = function (eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        result = (this._MdTooltip_0_8.handleEvent(eventName, $event) && result);
        return result;
    };
    return View_ModelingComponent1;
}(import2.AppView));
var renderType_ModelingComponent = import3.createRenderComponentType('', 0, import6.ViewEncapsulation.Emulated, styles_ModelingComponent, {
    'routeAnimationRight': ModelingComponent_routeAnimationRight_factory,
    'openHide': ModelingComponent_openHide_factory
});
var View_ModelingComponent0 = (function (_super) {
    __extends(View_ModelingComponent0, _super);
    function View_ModelingComponent0(viewUtils, parentView, parentIndex, parentElement) {
        var _this = _super.call(this, View_ModelingComponent0, renderType_ModelingComponent, import12.ViewType.COMPONENT, viewUtils, parentView, parentIndex, parentElement, import13.ChangeDetectorStatus.CheckAlways) || this;
        _this._expr_32 = import1.UNINITIALIZED;
        return _this;
    }
    View_ModelingComponent0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.parentElement);
        this._viewQuery_launch_0 = new import37.QueryList();
        this._viewQuery_graphView_1 = new import37.QueryList();
        this._el_0 = import3.createRenderElement(this.renderer, parentRenderNode, 'section', new import3.InlineArray2(2, 'class', 'wrapper wrapper__modeling'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n        ', null);
        this._el_2 = import3.createRenderElement(this.renderer, this._el_0, 'h2', import3.EMPTY_INLINE_ARRAY, null);
        this._text_3 = this.renderer.createText(this._el_2, 'Visualization', null);
        this._text_4 = this.renderer.createText(this._el_0, '\n        ', null);
        this._el_5 = import3.createRenderElement(this.renderer, this._el_0, 'form', import3.EMPTY_INLINE_ARRAY, null);
        this._NgForm_5_3 = new import38.Wrapper_NgForm(null, null);
        this._ControlContainer_5_4 = this._NgForm_5_3.context;
        this._NgControlStatusGroup_5_5 = new import39.Wrapper_NgControlStatusGroup(this._ControlContainer_5_4);
        this._text_6 = this.renderer.createText(this._el_5, '\n            ', null);
        this._anchor_7 = this.renderer.createTemplateAnchor(this._el_5, null);
        this._vc_7 = new import24.ViewContainer(7, 5, this, this._anchor_7);
        this._TemplateRef_7_5 = new import45.TemplateRef_(this, 7, this._anchor_7);
        this._NgFor_7_6 = new import40.Wrapper_NgFor(this._vc_7.vcRef, this._TemplateRef_7_5, this.parentView.injectorGet(import46.IterableDiffers, this.parentIndex), this.ref);
        this._text_8 = this.renderer.createText(this._el_5, '\n            ', null);
        this._el_9 = import3.createRenderElement(this.renderer, this._el_5, 'button', new import3.InlineArray4(4, 'class', 'modeling__btn', 'md-raised-button', ''), null);
        this.compView_9 = new import42.View_MdButton0(this.viewUtils, this, 9, this._el_9);
        this._MdPrefixRejector_9_3 = new import28.Wrapper_MdPrefixRejector(this.parentView.injectorGet(import30.MATERIAL_COMPATIBILITY_MODE, this.parentIndex, null));
        this._MdButton_9_4 = new import42.Wrapper_MdButton(new import33.ElementRef(this._el_9), this.renderer);
        this._MdRaisedButtonCssMatStyler_9_5 = new import42.Wrapper_MdRaisedButtonCssMatStyler();
        this._text_10 = this.renderer.createText(null, 'Launch', null);
        this.compView_9.create(this._MdButton_9_4.context);
        this._text_11 = this.renderer.createText(this._el_5, '\n            ', null);
        this._el_12 = import3.createRenderElement(this.renderer, this._el_5, 'progress-spinner-i', import3.EMPTY_INLINE_ARRAY, null);
        this.compView_12 = new import44.View_SpinnerComponent0(this.viewUtils, this, 12, this._el_12);
        this._SpinnerComponent_12_3 = new import44.Wrapper_SpinnerComponent();
        this._text_13 = this.renderer.createText(null, '   \n            ', null);
        this.compView_12.create(this._SpinnerComponent_12_3.context);
        this._text_14 = this.renderer.createText(this._el_5, '       \n        ', null);
        this._text_15 = this.renderer.createText(this._el_0, '\n        ', null);
        this._el_16 = import3.createRenderElement(this.renderer, this._el_0, 'div', new import3.InlineArray2(2, 'id', 'graphView'), null);
        this._text_17 = this.renderer.createText(this._el_0, '\n    ', null);
        var disposable_0 = import3.subscribeToRenderElement(this, this._el_5, new import3.InlineArray4(4, 'submit', null, 'reset', null), this.eventHandler(this.handleEvent_5));
        var disposable_1 = import3.subscribeToRenderElement(this, this._el_9, new import3.InlineArray8(6, 'mousedown', null, 'focus', null, 'blur', null), this.eventHandler(this.handleEvent_9));
        this._viewQuery_launch_0.reset([new import33.ElementRef(this._el_9)]);
        this.context.launch = this._viewQuery_launch_0.first;
        this._viewQuery_graphView_1.reset([new import33.ElementRef(this._el_16)]);
        this.context.graphView = this._viewQuery_graphView_1.first;
        this.init(null, (this.renderer.directRenderer ? null : [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4,
            this._el_5,
            this._text_6,
            this._anchor_7,
            this._text_8,
            this._el_9,
            this._text_10,
            this._text_11,
            this._el_12,
            this._text_13,
            this._text_14,
            this._text_15,
            this._el_16,
            this._text_17
        ]), [
            disposable_0,
            disposable_1
        ]);
        return null;
    };
    View_ModelingComponent0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import45.TemplateRef) && (7 === requestNodeIndex))) {
            return this._TemplateRef_7_5;
        }
        if (((token === import47.NgFor) && (7 === requestNodeIndex))) {
            return this._NgFor_7_6.context;
        }
        if (((token === import30.MdPrefixRejector) && ((9 <= requestNodeIndex) && (requestNodeIndex <= 10)))) {
            return this._MdPrefixRejector_9_3.context;
        }
        if (((token === import41.MdButton) && ((9 <= requestNodeIndex) && (requestNodeIndex <= 10)))) {
            return this._MdButton_9_4.context;
        }
        if (((token === import41.MdRaisedButtonCssMatStyler) && ((9 <= requestNodeIndex) && (requestNodeIndex <= 10)))) {
            return this._MdRaisedButtonCssMatStyler_9_5.context;
        }
        if (((token === import43.SpinnerComponent) && ((12 <= requestNodeIndex) && (requestNodeIndex <= 13)))) {
            return this._SpinnerComponent_12_3.context;
        }
        if (((token === import48.NgForm) && ((5 <= requestNodeIndex) && (requestNodeIndex <= 14)))) {
            return this._NgForm_5_3.context;
        }
        if (((token === import49.ControlContainer) && ((5 <= requestNodeIndex) && (requestNodeIndex <= 14)))) {
            return this._ControlContainer_5_4;
        }
        if (((token === import50.NgControlStatusGroup) && ((5 <= requestNodeIndex) && (requestNodeIndex <= 14)))) {
            return this._NgControlStatusGroup_5_5.context;
        }
        return notFoundResult;
    };
    View_ModelingComponent0.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_32 = this.context.spTgl;
        if (import3.checkBinding(throwOnChange, this._expr_32, currVal_32)) {
            var animationTransition_openHide = this.componentType.animations['openHide'](this, this._el_12, ((this._expr_32 == import1.UNINITIALIZED) ? 'void' : this._expr_32), ((currVal_32 == import1.UNINITIALIZED) ? 'void' : currVal_32));
            this._expr_32 = currVal_32;
        }
        this._NgForm_5_3.ngDoCheck(this, this._el_5, throwOnChange);
        this._NgControlStatusGroup_5_5.ngDoCheck(this, this._el_5, throwOnChange);
        var currVal_7_0_0 = this.context.inputs;
        this._NgFor_7_6.check_ngForOf(currVal_7_0_0, throwOnChange, false);
        this._NgFor_7_6.ngDoCheck(this, this._anchor_7, throwOnChange);
        this._MdPrefixRejector_9_3.ngDoCheck(this, this._el_9, throwOnChange);
        if (this._MdButton_9_4.ngDoCheck(this, this._el_9, throwOnChange)) {
            this.compView_9.markAsCheckOnce();
        }
        this._MdRaisedButtonCssMatStyler_9_5.ngDoCheck(this, this._el_9, throwOnChange);
        var currVal_12_0_0 = this.context.spStVal;
        this._SpinnerComponent_12_3.check_value(currVal_12_0_0, throwOnChange, false);
        this._SpinnerComponent_12_3.ngDoCheck(this, this._el_12, throwOnChange);
        this._vc_7.detectChangesInNestedViews(throwOnChange);
        this._NgControlStatusGroup_5_5.checkHost(this, this, this._el_5, throwOnChange);
        this._MdButton_9_4.checkHost(this, this.compView_9, this._el_9, throwOnChange);
        this._MdRaisedButtonCssMatStyler_9_5.checkHost(this, this.compView_9, this._el_9, throwOnChange);
        this.compView_9.internalDetectChanges(throwOnChange);
        this.compView_12.internalDetectChanges(throwOnChange);
    };
    View_ModelingComponent0.prototype.destroyInternal = function () {
        this._vc_7.destroyNestedViews();
        this.compView_9.destroy();
        this.compView_12.destroy();
        this._NgForm_5_3.ngOnDestroy();
    };
    View_ModelingComponent0.prototype.detachInternal = function () {
        var animationTransition_openHide = this.componentType.animations['openHide'](this, this._el_12, this._expr_32, 'void');
    };
    View_ModelingComponent0.prototype.visitProjectableNodesInternal = function (nodeIndex, ngContentIndex, cb, ctx) {
        if (((nodeIndex == 9) && (ngContentIndex == 0))) {
            cb(this._text_10, ctx);
        }
    };
    View_ModelingComponent0.prototype.createEmbeddedViewInternal = function (nodeIndex) {
        if ((nodeIndex == 7)) {
            return new View_ModelingComponent1(this.viewUtils, this, 7, this._anchor_7, this._vc_7);
        }
        return null;
    };
    View_ModelingComponent0.prototype.handleEvent_5 = function (eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        result = (this._NgForm_5_3.handleEvent(eventName, $event) && result);
        return result;
    };
    View_ModelingComponent0.prototype.handleEvent_9 = function (eventName, $event) {
        this.compView_9.markPathToRootAsCheckOnce();
        var result = true;
        result = (this._MdButton_9_4.handleEvent(eventName, $event) && result);
        return result;
    };
    return View_ModelingComponent0;
}(import2.AppView));
export { View_ModelingComponent0 };
var renderType_ModalWindowComponent_Host = import3.createRenderComponentType('', 0, import6.ViewEncapsulation.None, [], {});
var View_ModalWindowComponent_Host0 = (function (_super) {
    __extends(View_ModalWindowComponent_Host0, _super);
    function View_ModalWindowComponent_Host0(viewUtils, parentView, parentIndex, parentElement) {
        return _super.call(this, View_ModalWindowComponent_Host0, renderType_ModalWindowComponent_Host, import12.ViewType.HOST, viewUtils, parentView, parentIndex, parentElement, import13.ChangeDetectorStatus.CheckAlways) || this;
    }
    View_ModalWindowComponent_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer, 'modal-wndw', import3.EMPTY_INLINE_ARRAY, rootSelector, null);
        this.compView_0 = new View_ModalWindowComponent0(this.viewUtils, this, 0, this._el_0);
        this._ModalWindowComponent_0_3 = new Wrapper_ModalWindowComponent(this.injectorGet(import51.MdDialogRef, this.parentIndex));
        this.compView_0.create(this._ModalWindowComponent_0_3.context);
        this.init(this._el_0, (this.renderer.directRenderer ? null : [this._el_0]), null);
        return new import14.ComponentRef_(0, this, this._el_0, this._ModalWindowComponent_0_3.context);
    };
    View_ModalWindowComponent_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import0.ModalWindowComponent) && (0 === requestNodeIndex))) {
            return this._ModalWindowComponent_0_3.context;
        }
        return notFoundResult;
    };
    View_ModalWindowComponent_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._ModalWindowComponent_0_3.ngDoCheck(this, this._el_0, throwOnChange);
        this.compView_0.internalDetectChanges(throwOnChange);
    };
    View_ModalWindowComponent_Host0.prototype.destroyInternal = function () {
        this.compView_0.destroy();
    };
    View_ModalWindowComponent_Host0.prototype.visitRootNodesInternal = function (cb, ctx) {
        cb(this._el_0, ctx);
    };
    return View_ModalWindowComponent_Host0;
}(import2.AppView));
export var ModalWindowComponentNgFactory = new import14.ComponentFactory('modal-wndw', View_ModalWindowComponent_Host0, import0.ModalWindowComponent);
var styles_ModalWindowComponent = ['h2[_ngcontent-%COMP%]{\n            text-align: center; \n            text-transform: uppercase;\n            margin: 0 0 0 40px;\n            padding: 0;\n        } \n        .modal-wndw__btn[_ngcontent-%COMP%]{\n            min-width: 40px; \n            padding: 0;\n            float: right;\n        }'];
var renderType_ModalWindowComponent = import3.createRenderComponentType('', 0, import6.ViewEncapsulation.Emulated, styles_ModalWindowComponent, {});
var View_ModalWindowComponent0 = (function (_super) {
    __extends(View_ModalWindowComponent0, _super);
    function View_ModalWindowComponent0(viewUtils, parentView, parentIndex, parentElement) {
        var _this = _super.call(this, View_ModalWindowComponent0, renderType_ModalWindowComponent, import12.ViewType.COMPONENT, viewUtils, parentView, parentIndex, parentElement, import13.ChangeDetectorStatus.CheckAlways) || this;
        _this._expr_14 = import1.UNINITIALIZED;
        return _this;
    }
    View_ModalWindowComponent0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.parentElement);
        this._text_0 = this.renderer.createText(parentRenderNode, '\n    ', null);
        this._el_1 = import3.createRenderElement(this.renderer, parentRenderNode, 'button', new import3.InlineArray4(4, 'class', 'modal-wndw__btn', 'md-button', ''), null);
        this.compView_1 = new import42.View_MdButton0(this.viewUtils, this, 1, this._el_1);
        this._MdPrefixRejector_1_3 = new import28.Wrapper_MdPrefixRejector(this.parentView.injectorGet(import30.MATERIAL_COMPATIBILITY_MODE, this.parentIndex, null));
        this._MdButton_1_4 = new import42.Wrapper_MdButton(new import33.ElementRef(this._el_1), this.renderer);
        this._MdButtonCssMatStyler_1_5 = new import42.Wrapper_MdButtonCssMatStyler();
        this._text_2 = this.renderer.createText(null, 'X', null);
        this.compView_1.create(this._MdButton_1_4.context);
        this._text_3 = this.renderer.createText(parentRenderNode, '\n    ', null);
        this._el_4 = import3.createRenderElement(this.renderer, parentRenderNode, 'h2', import3.EMPTY_INLINE_ARRAY, null);
        this._text_5 = this.renderer.createText(this._el_4, '', null);
        this._text_6 = this.renderer.createText(parentRenderNode, '\n    ', null);
        this._el_7 = import3.createRenderElement(this.renderer, parentRenderNode, 'stub-cmpnt', import3.EMPTY_INLINE_ARRAY, null);
        this.compView_7 = new import53.View_StubComponent0(this.viewUtils, this, 7, this._el_7);
        this._StubComponent_7_3 = new import53.Wrapper_StubComponent(this.renderer);
        this.compView_7.create(this._StubComponent_7_3.context);
        var disposable_0 = import3.subscribeToRenderElement(this, this._el_1, new import3.InlineArray8(8, 'click', null, 'mousedown', null, 'focus', null, 'blur', null), this.eventHandler(this.handleEvent_1));
        this.init(null, (this.renderer.directRenderer ? null : [
            this._text_0,
            this._el_1,
            this._text_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._text_6,
            this._el_7
        ]), [disposable_0]);
        return null;
    };
    View_ModalWindowComponent0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import30.MdPrefixRejector) && ((1 <= requestNodeIndex) && (requestNodeIndex <= 2)))) {
            return this._MdPrefixRejector_1_3.context;
        }
        if (((token === import41.MdButton) && ((1 <= requestNodeIndex) && (requestNodeIndex <= 2)))) {
            return this._MdButton_1_4.context;
        }
        if (((token === import41.MdButtonCssMatStyler) && ((1 <= requestNodeIndex) && (requestNodeIndex <= 2)))) {
            return this._MdButtonCssMatStyler_1_5.context;
        }
        if (((token === import52.StubComponent) && (7 === requestNodeIndex))) {
            return this._StubComponent_7_3.context;
        }
        return notFoundResult;
    };
    View_ModalWindowComponent0.prototype.detectChangesInternal = function (throwOnChange) {
        this._MdPrefixRejector_1_3.ngDoCheck(this, this._el_1, throwOnChange);
        if (this._MdButton_1_4.ngDoCheck(this, this._el_1, throwOnChange)) {
            this.compView_1.markAsCheckOnce();
        }
        this._MdButtonCssMatStyler_1_5.ngDoCheck(this, this._el_1, throwOnChange);
        var currVal_7_0_0 = this.context.element;
        this._StubComponent_7_3.check_body(currVal_7_0_0, throwOnChange, false);
        this._StubComponent_7_3.ngDoCheck(this, this._el_7, throwOnChange);
        this._MdButton_1_4.checkHost(this, this.compView_1, this._el_1, throwOnChange);
        this._MdButtonCssMatStyler_1_5.checkHost(this, this.compView_1, this._el_1, throwOnChange);
        var currVal_14 = import3.inlineInterpolate(1, '', this.context.title, '');
        if (import3.checkBinding(throwOnChange, this._expr_14, currVal_14)) {
            this.renderer.setText(this._text_5, currVal_14);
            this._expr_14 = currVal_14;
        }
        this.compView_1.internalDetectChanges(throwOnChange);
        this.compView_7.internalDetectChanges(throwOnChange);
        if (!throwOnChange) {
            if ((this.numberOfChecks === 0)) {
                this._StubComponent_7_3.context.ngAfterViewInit();
            }
        }
    };
    View_ModalWindowComponent0.prototype.destroyInternal = function () {
        this.compView_1.destroy();
        this.compView_7.destroy();
    };
    View_ModalWindowComponent0.prototype.visitProjectableNodesInternal = function (nodeIndex, ngContentIndex, cb, ctx) {
        if (((nodeIndex == 1) && (ngContentIndex == 0))) {
            cb(this._text_2, ctx);
        }
    };
    View_ModalWindowComponent0.prototype.handleEvent_1 = function (eventName, $event) {
        this.compView_1.markPathToRootAsCheckOnce();
        var result = true;
        result = (this._MdButton_1_4.handleEvent(eventName, $event) && result);
        if ((eventName == 'click')) {
            var pd_sub_0 = (this.context.dialogRef.close() !== false);
            result = (pd_sub_0 && result);
        }
        return result;
    };
    return View_ModalWindowComponent0;
}(import2.AppView));
export { View_ModalWindowComponent0 };
//# sourceMappingURL=modeling.component.ngfactory.js.map